import React from 'react';

type ActivityButtonProps = React.PropsWithoutRef<JSX.IntrinsicElements['button']> & {
    isActive?: boolean;
    className?: string;
    onClick: () => void;
    dangerouslySetInnerHTML?: any;
}

/**
 * Simple HTML button to represent activity. When isActive=true, the button text is replaced with a spinning icon
 * and the onClick handler is disabled
 * NOTE: This component depends on Fontawesome 5.x
 *
 * @param isActive
 * @param onClick
 * @param children
 * @param rest
 * @constructor
 */
export const ActivityButton: React.FunctionComponent<ActivityButtonProps> = ({
                                                                                 isActive = false,
                                                                                 onClick,
                                                                                 dangerouslySetInnerHTML,
                                                                                 children,
                                                                                 ...rest
                                                                             }) => {

    // only allow pass thru of dangerouslySetInnerHTML if button is inactive
    let props: any = {};
    if (!isActive && dangerouslySetInnerHTML) {
        props.dangerouslySetInnerHTML = dangerouslySetInnerHTML;
    }

    return (
        <button type="button"
                onClick={() => {
                    !isActive && onClick();
                }}
                {...props}
                {...rest}
        >
            {isActive ?
                <i className="fas fa-spinner fa-spin"/>
                :
                dangerouslySetInnerHTML ? null : children}
        </button>
    );
};
